import React, { FC } from 'react';
import { Typography, TypographyProps, styled, Theme } from '@material-ui/core';

const ChapterNumberWrapper = styled(Typography)<Theme>(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'stretch',
  padding: 0,
  fontFamily: theme.config.secondaryFontFamily,
  fontSize: theme.typography.h5.fontSize,
  fontVariantNumeric: 'tabular-nums',
  color: theme.palette.primary.main,
  minWidth: 42,
}));

const ChapterNumber: FC<TypographyProps> = ({ color, ...other }) => (
  <ChapterNumberWrapper color={color || 'primary'} {...other} />
);

export default ChapterNumber;
